import type { GenderType } from '@/types/domain/child/valueObjects/gender';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 性別
 */
export class Gender extends PrimitiveValueObject<GenderType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: GenderType): Gender {
    return new Gender(value);
  }

  /** ラベル */
  static get label(): string {
    return '性別';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '男';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'gender';
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    return [{ id: '男', name: '男' }, { id: '女', name: '女' }];
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
